var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { QuestionPassStateId } from '../../../learnware/LearnwareEnums';
import { runtime } from '../../../runtime/Runtime';
export class MiniQuestionBrandingScore {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get mini() {
        return this.parent;
    }
    get app() {
        return this.mini.app;
    }
    /* Scoring */
    get scoreTotal() {
        if (!this.mini.micro)
            return -9999;
        const totalScore = this.scoreLeastOftenShown + this.scoreSuccession + this.scoreDayOfYearCorridor;
        return Math.round(totalScore);
    }
    get scoreLeastOftenShown() {
        if (this.mini.miniPassState.questionState === QuestionPassStateId.New)
            return 100000;
        if (this.mini.miniPassState.questionState === QuestionPassStateId.Passed)
            return 10000;
        if (this.mini.miniPassState.questionState === QuestionPassStateId.Passed2)
            return 1000;
        if (this.mini.miniPassState.questionState === QuestionPassStateId.Passed3)
            return 0;
        return 0;
    }
    get scoreDayOfYearCorridor() {
        const { minDayOfYear, maxDayOfYear } = this.mini.scoringStore;
        if (!minDayOfYear && !maxDayOfYear)
            return 0;
        const dayOfYear = runtime.runtimeClock.todaysDayOfYear;
        if (!maxDayOfYear) {
            if (dayOfYear >= minDayOfYear)
                return 0;
            return -1000000;
        }
        if (!minDayOfYear) {
            if (dayOfYear <= maxDayOfYear)
                return 0;
            return -1000000;
        }
        if (minDayOfYear <= maxDayOfYear) {
            if (dayOfYear >= minDayOfYear && dayOfYear <= maxDayOfYear)
                return 0;
            return -1000000;
        }
        if (minDayOfYear > maxDayOfYear) {
            if (dayOfYear <= maxDayOfYear)
                return 0;
            if (dayOfYear >= minDayOfYear)
                return 0;
            return -1000000;
        }
    }
    get scoreSuccession() {
        return 10000 - this.mini.micro.successionIndex;
    }
}
__decorate([
    computed
], MiniQuestionBrandingScore.prototype, "scoreTotal", null);
